const ListTable = require('app/ui/list/Table');
const ConfirmModal = require('app/ui/modal/Confirm');
const Modal = require('app/ui/Modal');
const GraphQLQuery = require('app/graphql/Query');
const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLMutation = require('app/graphql/Mutation');

class IndexView {
    defaultOptions() {
        return {
            'selector': '.view-billing-tracking',
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.buildGeneralFooter = this.buildGeneralFooter.bind(this);
        this.buildSupplierFooter = this.buildSupplierFooter.bind(this);
        this.buildGraphQLSupplierParameters = this.buildGraphQLSupplierParameters.bind(this);
        this.buildGraphQLGeneralParameters  = this.buildGraphQLGeneralParameters.bind(this);
        this.onSubmitFilterForm = this.onSubmitFilterForm.bind(this);

        this.$container = $(this.settings.selector);
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.$form = $('.billing-tracking-form',this.$container);
        this.$monthSelect = $('select[name="month"]',this.$form);
        this.$resultContainer= $('.billing-tracking-result-container',this.$container);   
        this.$btnRefresh = $('.btn-refresh',this.$form);

        this.list = [];
        this.initialize();
    }

    initialize() {
        var self = this;

        this.initializeFilterForm();
    }

    initializeFilterForm(){
        var self = this;

        this.$monthSelect.on('change',this.onSubmitFilterForm);
        this.$form.on('submit',this.onSubmitFilterForm);
        this.$btnRefresh.on('click',this.onSubmitFilterForm);

    }

    refresh(){
        this.$btnRefresh.trigger('click');
    }

    onSubmitFilterForm(event){
        event.preventDefault()
        event.stopPropagation();

        this.$resultContainer.hide();

        this.clearTabs();
        if(this.$monthSelect.val()){
            this.loadData();
        }
    }

    clearTabs(){
        $('.tab-body',this.$resultContainer)
        .html('')
        .append(window.App.generateLoader(false));
    }

    getListContainers(){
        return $('.tracking-result-container',this.$resultContainer);
    }

    getSuppliers(){
        let $containers = this.getListContainers();
        let suppliers = [];
        $containers.each(function(){
            let $container = $(this);
            if($container.data('type') == 'supplier'){
                suppliers.push($container.data('id'));
            }
        });
        return suppliers;
    }


    initializeLists(){
        var self = this;
        let $lists = $('.tracking-result-container',this.$resultContainer);
        $lists.each(function(){
            let $list = $(this);
            self.list.push(self.initializeList($list));
        })
    }

    initializeList($list){
        var self = this;
        let type = $list.data('type');
        let id = $list.data('id');
        let query = 'billingAnalyseBySupplier';
        let footerCallback = this.buildSupplierFooter;
        let queryBuilder = this.buildGraphQLSupplierParameters;
        let columns = [];

        if(type == 'general'){
            id = 'general';
            query = 'billingAnalyseGeneral';
            footerCallback = this.buildGeneralFooter;
            queryBuilder = this.buildGraphQLGeneralParameters;
        }

        let fields = [
            'month',
            'totalPurchase',
            'totalIncome',
            'totalMargin',
            'totalGain',
        ];

        switch(type){
            case 'supplier':
                fields.push('supplier{ id name }');
                fields.push('rows { restaurant { id name } incomes purchases margin gain }');

                columns.push({
                    'name': 'client',
                    'label': "Client",
                    'class': 'billing-tracking-client col-6',
                    'render': function(item,index){
                        return item.restaurant.name;
                    },
                });
                
                columns.push({
                    'name': 'income',
                    'label': "Ventes",
                    'class': 'billing-tracking-income text-end',
                    'render': function(item,index,list){
                        let $btn = $('<button/>')
                        .addClass('btn btn-link text-primary text-decoration-none')
                        .data('item',item)
                        .append(window.formatFloat(item.incomes) + ' &euro;')
                        .on("click",function(event){
                            event.preventDefault();
                            event.stopPropagation();

                            let $btn = $(this);
                            let item = $btn.data('item');
                            let supplier = list.rawData.supplier;

                            self.openRestaurantModal(supplier,item.restaurant,'income');

                        });

                        return $btn;
                    },
                });
                columns.push({
                    'name': 'purchase',
                    'label': "Achats (RFA incluse)",
                    'class': 'billing-tracking-purchase text-end',
                    'render': function(item,index,list){
                        let $btn = $('<button/>')
                        .addClass('btn btn-link text-primary text-decoration-none')
                        .data('item',item)
                        .append(window.formatFloat(item.purchases) + ' &euro;')
                        .on("click",function(event){
                            event.preventDefault();
                            event.stopPropagation();

                            let $btn = $(this);
                            let item = $btn.data('item');
                            let supplier = list.rawData.supplier;

                            self.openRestaurantModal(supplier,item.restaurant,'purchase');

                        });
                        
                        return $btn;
                    },
                });
                columns.push({
                    'name': 'gain',
                    'label': "Total gain HT Restofuté",
                    'class': 'billing-tracking-gain text-end',
                    'render': function(item,index){
                        return window.formatFloat(item.gain) + ' &euro;';
                    },
                });
                columns.push({
                    'name': 'margin',
                    'label': "% Marge",
                    'class': 'billing-tracking-gain text-end',
                    'render': function(item,index){
                        return window.formatFloat(item.margin) + '%';
                    },
                });
            break;

            case 'general':
                fields.push('rows { supplier { id name } incomes purchases margin gain rfa }');
                fields.push('totalRFA');
                fields.push('totalCredit');

                
                columns.push({
                    'name': 'supplier',
                    'label': "Totaux par fournisseurs",
                    'class': 'billing-tracking-supplier col-6',
                    'render': function(item,index){
                        return item.supplier.name;
                    },
                });
                
                columns.push({
                    'name': 'income',
                    'label': "Ventes",
                    'class': 'billing-tracking-income text-end',
                    'render': function(item,index){
                        return window.formatFloat(item.incomes)+ ' &euro;';
                    },
                });
                columns.push({
                    'name': 'purchase',
                    'label': "Achats (RFA incluse)",
                    'class': 'billing-tracking-purchase text-end',
                    'render': function(item,index){
                        return window.formatFloat(item.purchases)+ ' &euro;';
                    },
                });
                columns.push({
                    'name': 'gain',
                    'label': "Total gain HT Restofuté",
                    'class': 'billing-tracking-gain text-end',
                    'render': function(item,index){
                        return window.formatFloat(item.gain)+ ' &euro;';
                    },
                });
                columns.push({
                    'name': 'margin',
                    'label': "% Marge",
                    'class': 'billing-tracking-gain text-end',
                    'render': function(item,index){
                        return window.formatFloat(item.margin) + '%';
                    },
                });
            break;
        }

        let list = new ListTable({
            '$container': $list,
            'tableClass': 'table table-striped billing-tracking-list',
            'hasEdges': false,
            'footerBuilder': {
                'mode': 'custom',
                'render': footerCallback,
            },
            'showPagination': false,
            'id': 'billing-tracking-list-'+id,
            'length': 10000,
            'graphQL': {
                'queryType': query,
                'fields': fields,
                'filter': {
                    'id' : id
                },
                'parameters': queryBuilder,

            },
            'columns': columns,
            'getDataFromRawData': function(raw,list){
                let data = {
                    'lines': raw.rows,
                    'totalCount': raw.rows.length,
                };
                return data;
            },
            'onDrawLine': function($row,item,index){
                if(type == 'general'){
                    let supplierId = item.supplier.id;
                    if(item.gain == 0 && item.incomes == 0 && item.purchases == 0){
                        $row.hide();
                    }else{
                        $('.billing-tracking-tab-link-'+supplierId,self.$container).show();
                    }
                }
            }
        });

        return list;

    }

    buildSupplierFooter(data,list){
        let rawData = list.rawData;
        let supplier = rawData.supplier;
        let totalGain = rawData.totalGain;
        let totalIncome = rawData.totalIncome;
        let totalMargin = rawData.totalMargin;
        let totalPurchase = rawData.totalPurchase;

        let $rowTotal = $('<tr/>')
        .addClass('text-bold')
        .append(
            $('<td/>')
            .addClass("col-6")
            .append("TOTAL "+ supplier.name)
        )
        .append(
            $('<td/>')
            .addClass('text-end')
            .append(window.formatFloat(totalIncome) + ' &euro;')
        )
        .append(
            $('<td/>')
            .addClass('text-end')
            .append(window.formatFloat(totalPurchase) + ' &euro;')
        )
        .append(
            $('<td/>')
            .addClass('text-end')
            .append(window.formatFloat(totalGain) + ' &euro;')
        )
        .append(
            $('<td/>')
            .addClass('text-end')
            .append(window.formatFloat(totalMargin) + ' %')
        )

        return $rowTotal;

    }
    
    buildGraphQLSupplierParameters(list){
        let supplier = list.settings.graphQL.filter.id;
        let parameters = {
            'supplier': supplier,
            'month': this.$monthSelect.val(),
        };
        return parameters;
    }
    
    buildGeneralFooter(data,list){
        var self = this;
        let rawData = list.rawData;

        let totalCredit = rawData.totalCredit;
        let totalGain = rawData.totalGain;
        let totalIncome = rawData.totalIncome;
        let totalMargin = rawData.totalMargin;
        let totalPurchase = rawData.totalPurchase;
        let totalRFA = rawData.totalRFA;
        
        let rows = [];

        let $rowRFA = $('<tr/>')
        .append(
            $('<td/>')
            .addClass("col-6")
            .append("TOTAL RFA FOURNISSEUR")
        )
        .append(
            $('<td/>')
            .addClass('text-end')
            .append('-')
        )
        .append(
            $('<td/>')
            .addClass('text-end')
            .append('-')
        )
        .append(
            $('<td/>')
            .addClass('text-end')
            .append(
                $("<button/>")
                .addClass('btn btn-link text-primary text-decoration-none')
                .attr('type','button')
                .append(window.formatFloat(totalRFA) + ' &euro;')
                .on('click',function(event){
                    event.preventDefault();
                    event.stopPropagation();
                    self.openRFAModal(data);
                })
            )
        )   
        .append(
            $('<td/>')
            .addClass('text-end')
            .append('-')
        )

        
        let $rowCredit = $('<tr/>')
        .append(
            $('<td/>')
            .addClass("col-6")
            .append("TOTAL AVOIRS CLIENTS")
        )
        .append(
            $('<td/>')
            .addClass('text-end')
            .append('-')
        )
        .append(
            $('<td/>')
            .addClass('text-end')
            .append('-')
        )
        .append(
            $('<td/>')
            .addClass('text-end')
            .append(
                $("<button/>")
                .addClass('btn btn-link text-primary text-decoration-none')
                .attr('type','button')
                .append(window.formatFloat(totalCredit) + ' &euro;')
                .on('click',function(event){
                    event.preventDefault();
                    event.stopPropagation();
                    self.openCreditModal();
                })
            )
        )
        .append(
            $('<td/>')
            .addClass('text-end')
            .append('-')
        )


        let $rowTotal = $('<tr/>')
        .addClass('text-bold')
        .append(
            $('<td/>')
            .addClass("col-6")
            .append("TOTAL GENERAL")
        )
        .append(
            $('<td/>')
            .addClass('text-end')
            .append(window.formatFloat(totalIncome) + ' &euro;')
        )
        .append(
            $('<td/>')
            .addClass('text-end')
            .append(window.formatFloat(totalPurchase) + ' &euro;')
        )
        .append(
            $('<td/>')
            .addClass('text-end')
            .append(window.formatFloat(totalGain) + ' &euro;')
        )
        .append(
            $('<td/>')
            .addClass('text-end')
            .append(window.formatFloat(totalMargin) + ' %')
        )

        rows.push($rowRFA);
        rows.push($rowCredit);
        rows.push($rowTotal);

        return rows;

    }
    
    buildGraphQLGeneralParameters(){
        let parameters = {
            'month': this.$monthSelect.val(),
        };
        return parameters;
    }
    

    loadData(){
        this.$resultContainer.show();
        $('.billing-tracking-tab-link',this.$container).hide();
        $('.billing-tracking-tab-link-general',this.$container)
        .show()
        .trigger('click');
        this.initializeLists();
    }

    getMonthLabel(){
        let $option = $('option:selected',this.$monthSelect);
        if($option.length <= 0){
            return '';
        }
        return $option.text();
    }

    openRFAModal(data){
        this.$content = $('<div/>')
        .addClass('rfa-modal')
        .append(window.App.generateLoader(false));
        let title = "RFA Fournisseurs " + this.getMonthLabel();
        let modal = new Modal({
            'id': 'rfaModal',
            'title': title,
            'showFooter': false,
            'content' : this.$content,
            'modalSize': "large",
            'onCloseDestroy': true,
        })

        this.loadRFAModalData(data,modal);

        modal.show();

    }

    loadRFAModalData(data,modal){
        var self = this;
        let $content = $('<div/>')
        .addClass('rfa-list');

        let $form = $('<form/>')
        .addClass('rfa-form');

        let total = 0;

        for(let item of data){
            let supplier = item.supplier;
            let rfa = item.rfa > 0 ? item.rfa : '';
            total += parseFloat(item.rfa);

            let $line = $('<div>')
            .addClass("mb-1")
            .addClass('row')
            .append(
                $('<div/>')
                .addClass('col-8')
                .append(
                    "RFA "+supplier.name
                )
            )
            .append(
                $('<div/>')
                .addClass('col-4 d-flex justify-content-end')
                .append(
                    $('<input/>')
                    .attr('type',"text")
                    .addClass('form-control text-end rfa-input')
                    .attr('name',"rfas["+supplier.id+"]")
                    .attr('placeholder',"+/- €")
                    .val(rfa)
                    .on('keyup',function(){
                        let total = 0;
                        $('.rfa-input').each(function(){
                            let val = $(this).val();
                            if(val){
                                total += parseFloat(val);
                            }
                        })
                        $('.rfa-total').html(window.formatFloat(total) + ' &euro;');
                    })
                )
            )

            $form.append($line);
        }
        
        $form
        .append(
            $('<div>')
            .addClass("mb-1")
            .addClass('row')
            .append(
                $('<div/>')
                .addClass('col-8 text-bold')
                .append(
                    "Total RFA Fournisseur "
                )
            )
            .append(
                $('<div/>')
                .addClass('col-4 d-flex justify-content-end text-bold rfa-total')
                .append(
                    window.formatFloat(total) + ' &euro;'
                )
            )
        );

        $form.append(
            $('<div/>')
            .addClass('d-flex justify-content-center mt-4')
            .append(
                $('<button/>')
                .attr('type',"submit")
                .addClass('btn btn-success btn-submit')
                .append(
                    $('<i/>')
                    .addClass('fas fa-save')
                )
                .append(' Enregistrer les RFA fournisseurs')
            )
        )
        

        $form.on('submit',function(event){
            event.preventDefault();
            event.stopPropagation();
            let data = new FormData(this);

            let $btn = $('.btn-submit',$(this));

            self.onSubmitRFAForm($btn, data,modal);
        })

        $content.append($form);

        modal.setBodyContent($content);
    }

    onSubmitRFAForm($btn,data,modal){
        var self = this;
        let mutation = new GraphQLMutation({
            'mutationType': "SubmitBillingAnalyseSupplierRFAs",
            'fields': [
                'success',
                'message',
                'errors { key, value }',
            ],
            'data':data,//FormData
            
            'variables': {
                'date': {
                    'value': this.$monthSelect.val()+"-01",
                    'type': 'String!'
                },
            },

            'before': function(){
                $btn.attr('disabled','disabled');
            },

            'success': function(data){
                window.notify(data.message,"success");
                self.refresh();
            },

            'error': function(message,data){
                console.error(message,data);
                window.notify(message,"danger");
            },

            'after': function(){
                $btn.removeAttr('disabled');
            }

        });
        
        mutation.execute();
    }

    openCreditModal(){
        this.$content = $('<div/>')
        .addClass('credit-modal')
        .append(window.App.generateLoader(false));
        let title = "Avoirs clients " + this.getMonthLabel();
        let modal = new Modal({
            'id': 'creditModal',
            'title': title,
            'showFooter': false,
            'content' : this.$content,
            'modalSize': "large",
            'onCloseDestroy': true,
        })

        this.loadCreditsModalData(modal);

        modal.show();

    }

    loadCreditsModalData(modal){


        var self = this;

        let fields = [
            'customer { name }',
            'reference',
            'ht',
        ];

        let $content = $('<div/>')
        .addClass('rfa-list');
        modal.setBodyContent($content);

        let table = new ListTable({
            '$container': $content,
            'tableClass': 'table table-striped billing-tracking-rfa-list',
            'showPagination': false,
            'id': 'list-billing-tracking-rfa',
            'length': 10000,
            'graphQL': {
                'queryType': 'billingInvoices',
                'fields': fields,
                'parameters': {
                    'orderBy': 'reference',
                    'dir': 'ASC',
                    'filter': {
                        'month': this.$monthSelect.val(),
                        'type': 2
                    }
                },

            },
            'footerBuilder': {
                'mode': 'custom',
                'render': function(data,list){
                    let total = 0;
                    for(let item of data){
                        total += parseFloat(item.node.ht);
                    }
                    let $row = $('<tr/>')
                    .addClass('text-bold')
                    .append(
                        $('<td/>')
                        .append('TOTAL AVOIRS CLIENTS')
                    )
                    .append(
                        $('<td/>')
                        .addClass('text-end')
                        .append(window.formatFloat(total) + " &euro;")
                    )

                    return $row;
                },
            },
            'columns': [
                {
                    'name': 'invoice',
                    'label': '',
                    'render': function(item,index){
                        return "Avoir " + item.node.reference + " (" + item.node.customer.name+ ")";
                    },
                },
                {
                    'name': 'value',
                    'label': '',
                    'class': "text-end",
                    'render': function(item,index){
                        return window.formatFloat(item.node.ht) + " &euro;";
                    },
                }
            ]
        })
    }

    openRestaurantModal(supplier,restaurant,type){
        this.$content = $('<div/>')
        .addClass('restaurant-modal')
        .append(window.App.generateLoader(false));

        let typeLabel = (type == 'purchase') ? 'Achats' : 'Ventes';
        let title = typeLabel + ' ' + this.getMonthLabel() + ' : ' + restaurant.name + ' / ' + supplier.name;


        let modal = new Modal({
            'id': 'restaurantModal'+supplier.id+"_"+restaurant.id+"_"+type,
            'title': title,
            'showFooter': false,
            'content' : this.$content,
            'modalSize': "large",
            'onCloseDestroy': true,
        })

        this.loadRestaurantModalData(supplier,restaurant,type,modal);

        modal.show();
    }

    loadRestaurantModalData(supplier,restaurant,type,modal){
        var self = this;
        let queries = [];

        let parameters = {
            'filter': {
                'month': this.$monthSelect.val(),
                'supplier': supplier.id,
                'restaurant': restaurant.id
            },
        };

        let fields = [
            'date',
            'purchases',
            'incomes',
        ];

        queries.push(
            new GraphQLQuery({
                'queryType': 'billingAnalyseTrackingInvoices',
                
                'parameters': parameters,
                'fields': fields,
                'hasEdges': true,
                'addPageInfo': false,
                'addTotalCount': false,
            })
        );
        
        fields = [
            'date',
            'nbPurchases',
            'nbIncomes',
        ];
        queries.push(
            new GraphQLQuery({
                'queryType': 'billingAnalyseTrackings',

                'parameters': parameters,
                'fields': fields,
                'hasEdges': true,
                'addPageInfo': false,
                'addTotalCount': false,
            })
        );

        fields = [
            'id',
            'date',
            'type',
            'total',
            'name',
        ];
        queries.push(
            new GraphQLQuery({
                'queryType': 'billingAnalyseTrackingInvoiceAdjustments',

                'parameters': parameters,
                'fields': fields,
                'hasEdges': true,
                'addPageInfo': false,
                'addTotalCount': false,
            })
        );

        let query = new GraphQLMultiQuery({
            'queries': queries,

            //callbacks
            'before': function(){
                modal.setBodyContent(
                    $('<div/>')
                    .append(window.App.generateLoader(false))
                );
            },
            'success': function(data){
                self.fillRestaurantModal(data,supplier,restaurant,type,modal);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();
    }

    fillRestaurantModal(graphqlData,supplier,restaurant,type,modal){
        var self = this;

        let invoices = graphqlData.billingAnalyseTrackingInvoices;
        if(invoices){
            invoices = invoices.edges;
        }
        let trackings = graphqlData.billingAnalyseTrackings;
        if(trackings){
            trackings = trackings.edges;
        }
        let adjustments = graphqlData.billingAnalyseTrackingInvoiceAdjustments;
        if(adjustments){
            adjustments = adjustments.edges;
        }
        
        let typeLabel = (type == 'purchase') ? 'Achats' : 'Ventes';
        let fieldValue = (type == 'purchase') ? 'purchases' : 'incomes';
        let data = [];
        for(let edge of invoices){
            let invoice = edge.node;
            let value = invoice[fieldValue];
            data.push({
                'type': 'invoice',
                'label': typeLabel + ' sur facture du '+ window.formatDate(invoice.date,'DD/MM/YYYY',false),
                'value': window.formatFloat(value) + ' &euro;',
                'action': '',
                'realValue': value,
            })
        }
        
        typeLabel = (type == 'purchase') ? 'achats' : 'ventes';
        fieldValue = (type == 'purchase') ? 'nbPurchases' : 'nbIncomes';
        for(let edge of trackings){
            let tracking = edge.node;
            let value = tracking[fieldValue];
            if(value){
                data.push({
                    'type': 'tracking',
                    'label': 'Prévisionnel ' + typeLabel + ' sur commandes du '+ window.formatDate(tracking.date,'DD/MM/YYYY',false),
                    'value': window.formatFloat(value) + ' &euro;',
                    'action': '',
                    'realValue': value,
                })
            }
        }

        for(let edge of adjustments){
            let adjustment = edge.node;
            if(adjustment.type == type){
                let $btnDeleteAdjustment = $('<button/>')
                .addClass('btn btn-text btn-icon text-primary btn-delete-adjusment')
                .attr('data-id',adjustment.id)
                .append(
                    $('<i/>')
                    .addClass('fas fa-trash')
                )
                .on('click',function(event){
                    event.preventDefault();
                    event.stopPropagation();
                    let $btn = $(this);
                    let id = $btn.data('id');
                    self.onClickBtnDeleteAdjustment($btn,id,supplier,restaurant,type,modal);
                })
                data.push({
                    'type': 'adjustment',
                    'label': adjustment.name,
                    'value': window.formatFloat(adjustment.total) + ' &euro;',
                    'action': $btnDeleteAdjustment,
                    'realValue': adjustment.total,
                })
            }
        }

        let $inputAdjustmentName = $('<input/>')
        .attr('type','text')
        .attr('name','adjustment-name')
        .addClass('form-control')
        .attr('placeholder','Ajouter une ligne');

        let $inputAdjustmentTotal = $('<input/>')
        .attr('type','text')
        .attr('name','adjustment-total')
        .addClass('form-control text-end')
        .attr('placeholder','-/+ €');

        let $adjusmentConfirm = $('<div/>')
        .append(
            $('<input/>')
            .attr('type','hidden')
            .attr('name','type')
            .val(type)
        )
        .append(
            $('<button/>')
            .attr('type','button')
            .addClass('btn btn-text text-success')
            .append(
                $('<i/>')
                .addClass('fas fa-save')
            )
            .on('click',function(event){
                event.preventDefault();
                event.stopPropagation();
                let name = $inputAdjustmentName.val();
                let total = $inputAdjustmentTotal.val();
                let $btn = $(this);
                if(name && total){
                    self.onClickBtnAddAdjustment($btn,name,total,supplier,restaurant,type,modal);
                }else{
                    window.notify("Veuillez saisir un nom et un montant","warning");
                }
            })
        )
        data.push({
            'type': 'adjustment-form',
            'label': $inputAdjustmentName,
            'value': $inputAdjustmentTotal,
            'action': $adjusmentConfirm,
            'realValue': 0,
        })

        let $content = $('<div/>');

        modal.setBodyContent($content);

        let list = new ListTable({
            '$container': $content,
            'tableClass': 'table table-striped billing-tracking-restaurant-list',
            'footerBuilder': {
                'mode': 'custom',
                'render': function(data,list){

                    let total = 0;
                    for(let item of data){
                        total += item.realValue;
                    }

                    let $row = $('<tr/>')
                    .addClass('text-bold')
                    .append(
                        $('<td/>')
                        .append('TOTAL')
                    )
                    .append(
                        $('<td/>')
                        .addClass('text-end')
                        .append(window.formatFloat(total) + ' &euro;')
                    )
                    .append(
                        $('<td/>')
                        .addClass('text-end')
                        .append('')
                    )
                    return $row;
                
                },
            },
            'showPagination': false,
            'id': 'billing-tracking-restaurant-list-'+supplier.id+'-'+restaurant.id+'-'+type,
            'length': 10000,
            'data': data,
            'columns': [
                {
                    'name': 'label',
                    'label': '',
                    'class': 'col-6',
                    'render': function(item,index){
                        return item.label;
                    }
                },
                {
                    'name': 'value',
                    'label': '',
                    'class': 'col-5 text-end',
                    'render': function(item,index){
                        return item.value;
                    }
                },
                {
                    'name': 'action',
                    'label': '',
                    'class': 'col-1 text-end',
                    'render': function(item,index){
                        return item.action;
                    }
                }
            ]

        })
    }

    onClickBtnDeleteAdjustment($btn,id,supplier,restaurant,type,modal){
        var self = this;
        if(confirm("Voulez-vous vraiment supprimer cette ligne ?")){
            
            let mutation = new GraphQLMutation({
                'mutationType': "DeleteBillingTrackingInvoiceAdjustment",

                'fields': [
                    'success',
                    'message',
                    'errors { key, value }',
                ],

                'variables': {
                    'id': {
                        'value': parseInt(id),
                        'type': 'Int!'
                    },
                },

                'before': function(){
                    $btn.attr('disabled','disabled');
                },

                'success': function(data){
                    window.notify(data.message,"success");
                    self.loadRestaurantModalData(supplier,restaurant,type,modal);
                    self.refresh();
                },

                'error': function(message,data){
                    console.error(message,data);
                    window.notify(message,"danger");
                },

                'after': function(){
                    $btn.removeAttr('disabled');
                }

            });
            
            mutation.execute();
        }
    }

    onClickBtnAddAdjustment($btn,name,total,supplier,restaurant,type,modal){
        var self = this;
        let date = this.$monthSelect.val()+'-01';

        let mutation = new GraphQLMutation({
            'mutationType': "SubmitBillingTrackingInvoiceAdjustment",

            'fields': [
                'success',
                'message',
                'errors { key, value }',
            ],

            'variables': {
                'date': {
                    'value': date,
                    'type': 'String!'
                },
                'type': {
                    'value': type,
                    'type': 'String!'
                },
                'restaurant': {
                    'value': parseInt(restaurant.id),
                    'type': 'Int!'
                },
                'supplier': {
                    'value': parseInt(supplier.id),
                    'type': 'Int!'
                },
                'name': {
                    'value': name,
                    'type': 'String!'
                },
                'total': {
                    'value': parseFloat(total),
                    'type': 'Float!'
                },
            },

            'before': function(){
                $btn.attr('disabled','disabled');
            },

            'success': function(data){
                window.notify(data.message,"success");
                self.loadRestaurantModalData(supplier,restaurant,type,modal);
                self.refresh();
            },

            'error': function(message,data){
                console.error(message,data);
                window.notify(message,"danger");
            },

            'after': function(){
                $btn.removeAttr('disabled');
            }

        });
        
        mutation.execute();
    }
}

module.exports = IndexView;

